module.exports = __webpack_public_path__ + "static/media/dkk.b57e24ee.jpg";